import React, {useState} from "react";
import {
    closeForm,
    endAnimation,
    FormName,
    formPropsSelector,
    isAnimationFinishedSelector,
    isFormOpenSelector,
    openedFormSelector
} from "./formSlice";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";

import styles from "./FormProvider.module.css"
import {CreateBotForm} from "../../modules/assistant/modal/CreateBotForm";
import {UpdateBotForm} from "../../modules/assistant/modal/UpdateBotForm";
import classnames from "classnames";
import {CreateLocationForm} from "../../modules/location/modal/CreateLocationForm";
import {UpdateLocationForm} from "../../modules/location/modal/UpdateLocationForm";
import {ConnectIntegrationForm} from "../../modules/assistant/page/integrations/modal/ConnectIntegrationForm";
import {UpdateIntegrationForm} from "../../modules/assistant/page/integrations/modal/UpdateIntegrationForm";
import {CreateOfferForm} from "../../modules/offer/modal/CreateOfferForm";
import {UpdateOfferForm} from "../../modules/offer/modal/UpdateOfferForm";
import {CreateFranchiseForm} from "../../modules/franchise/modal/CreateFranchiseForm";
import {UpdateFranchiseForm} from "../../modules/franchise/modal/UpdateFranchiseForm";
import {KnowledgeDefinitionForm} from "../../modules/knowledgeSettings/modal/KnowledgeDefinitionForm";

interface FormProviderProps {
    children: any
}

export const FormProvider: React.FC<FormProviderProps> = ({
                                                              children
                                                          }) => {

    const dispatch = useAppDispatch()

    const formProps = useAppSelector(formPropsSelector)

    const handleClick = () => {
        if (isFormOpen) {
            dispatch(closeForm())
            setTimeout(() => {
                dispatch(endAnimation())
            }, 500)
        }
    }

    const openFormMap: Partial<Record<FormName, JSX.Element>> = {}

    openFormMap[FormName.CREATE_BOT] = <CreateBotForm handleClose={handleClick} {...formProps}/>
    openFormMap[FormName.UPDATE_BOT] = <UpdateBotForm handleClose={handleClick} {...formProps}/>
    openFormMap[FormName.CREATE_LOCATION] = <CreateLocationForm handleClose={handleClick} {...formProps}/>
    openFormMap[FormName.UPDATE_LOCATION] = <UpdateLocationForm handleClose={handleClick} {...formProps}/>
    openFormMap[FormName.CREATE_FRANCHISE] = <CreateFranchiseForm handleClose={handleClick} {...formProps}/>
    openFormMap[FormName.UPDATE_FRANCHISE] = <UpdateFranchiseForm handleClose={handleClick} {...formProps}/>
    openFormMap[FormName.CONNECT_INTEGRATION] = <ConnectIntegrationForm handleClose={handleClick} {...formProps}/>
    openFormMap[FormName.UPDATE_INTEGRATION] = <UpdateIntegrationForm handleClose={handleClick} {...formProps}/>
    openFormMap[FormName.CREATE_OFFER] = <CreateOfferForm handleClose={handleClick} {...formProps}/>
    openFormMap[FormName.UPDATE_OFFER] = <UpdateOfferForm handleClose={handleClick} {...formProps}/>
    openFormMap[FormName.KNOWLEDGE_DEFINITION] = <KnowledgeDefinitionForm handleClose={handleClick} {...formProps}/>

    const [isInsideModal, setIsInsideModal] = useState(false);
    const isFormOpen = useAppSelector(isFormOpenSelector);
    const openedModal = useAppSelector(openedFormSelector);
    const isAnimationFinished = useAppSelector(isAnimationFinishedSelector);

    const handleMouseDown = (e: React.MouseEvent) => {
        const target = e.target as HTMLElement;
        setIsInsideModal(
            target.closest(`.${styles.modalWrapper}`) !== null ||
            target.closest(".react-select__control") !== null || // Prevent closing when clicking on select
            target.closest(".react-select__menu") !== null // Prevent closing when clicking inside dropdown
        );
    };

    const handleMouseUp = (e: React.MouseEvent) => {
        if (!isInsideModal && isFormOpen) {
            dispatch(closeForm());
            setTimeout(() => {
                dispatch(endAnimation());
            }, 500);
        }
    };

    return <div onMouseUp={handleMouseUp} onMouseDown={handleMouseDown}>
        {!(isAnimationFinished && !isFormOpen) &&
            <div
                className={classnames(styles.modalWrapper, (!isFormOpen && isAnimationFinished) && styles.modalClosed)}
                onClick={(e) => e.stopPropagation()}
                style={{
                    animation: isFormOpen
                        ? `${styles.slideIn} 0.5s ease forwards`
                        : `${styles.slideOut} 0.5s ease forwards`,
                }}
            >
                {openFormMap[openedModal!]}
            </div>
        }
        <div
            className={classnames(isFormOpen ? styles.outsideModalOpen : styles.outsideModalClosed, (!isFormOpen && isAnimationFinished) && styles.modalClosed)}/>
        {children}
    </div>
}
